import HBButton from "@/components/HBButton";
import { AB_CREATIVE_EXTENSION } from "@/constants/ABMng";
import useABTest from "@/utils/hooks/useABtest";
import { huabanArtHost } from "@/utils/host";
import { useCallback } from "react";

export default function CreativeExtensionButton({
  pin,
  className,
  searchWord,
}: {
  pin: IPin;
  className?: string;
  searchWord?: string;
}) {
  const onCreativeExtension = useCallback(() => {
    // https://www.gaoding.art/remix/:id?from=art
    window.open(
      `https://${huabanArtHost}/remix/${pin?.file_art?.content_id}?from=huaban`,
      "_blank"
    );
  }, [pin]);

  const creativeExtensionAB = useABTest(AB_CREATIVE_EXTENSION);

  if (!(pin.extension_count > 0 && creativeExtensionAB.new)) {
    return null;
  }

  return (
    <HBButton
      className={className}
      onClick={onCreativeExtension}
      theme="gray"
      data-gd-click="button_click"
      data-button-name="创意延展"
      data-module-name="素材信息"
      data-search-word={searchWord}
      data-pin-detail
      data-content={pin?.file_art?.content_id}
    >
      创意延展 × {pin.extension_count}
    </HBButton>
  );
}
